import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { catchError, EMPTY } from 'rxjs';
import { ChangePasswordReq, SignupReq } from 'src/app/api/contracts/auth';
import { DeleteProfileReq } from 'src/app/api/contracts/client';
import { APP_CONFIG, AppConfig } from 'src/app/config/app-config';
import { ClientService } from 'src/app/services/client.service';
import { ModalService } from 'src/app/services/modal.service';
import { LoaderController } from 'src/app/utils/loader-controller';
import { confirmPasswordFormValidator } from 'src/app/validators/confirm-password.validator';

@Component({
  selector: 'app-delete-profile',
  templateUrl: './delete-profile.component.html',
  styleUrls: ['./delete-profile.component.scss'],
})
export class DeleteProfileComponent implements OnInit {
  readonly form: FormGroup<{ currentPassword: FormControl }>;

  public readonly loader = new LoaderController();
  public requestFailedWithError: boolean = false;

  constructor(
    @Inject(APP_CONFIG) private readonly appConfig: AppConfig,
    private readonly clientService: ClientService,
    public readonly modalService: ModalService
  ) {
    this.form = new FormGroup({
      currentPassword: new FormControl('', [
        Validators.required,
        Validators.maxLength(64),
      ]),
    });
  }

  ngOnInit() {
    this.form.valueChanges.subscribe(() => {
      this.requestFailedWithError = false;
    });
  }

  onDeleteAccount(): void {
    this.loader.enqueue();
    this.form.disable();
    this.requestFailedWithError = false;
    const body: DeleteProfileReq = {
      currentPassword: this.form.controls.currentPassword.value,
    };
    this.clientService
      .deleteProfile(body)
      .pipe(
        catchError((err) => {
          this.form.enable();
          this.loader.dequeue();
          this.requestFailedWithError = true;
          return EMPTY;
        })
      )
      .subscribe(() => {
        this.form.enable();
        this.loader.dequeue();
        this.modalService.dismiss(true);
      });
  }
}
